import {SharedModule} from '../../../shared/shared.module';
import {UserDetailsModule} from '../user-details/user-details.module';
import {UserListComponent} from './user-list.component';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions'
import { TypeaheadModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    NgbModule,
    DataTableModule,
    SharedModule,
    UserDetailsModule,
    TypeaheadModule
  ],
  declarations: [UserListComponent],
  exports: [UserListComponent],
  providers: []
})
export class UserListModule {

}
